import { createPortal } from "react-dom";
import { WifiOff, Wifi } from "lucide-react";
import { useOnlineStatus } from "../hooks/useOnlineStatus";

export function OfflineBanner() {
  const { isOnline, justCameOnline } = useOnlineStatus();

  if (isOnline && !justCameOnline) return null;

  if (justCameOnline) {
    return createPortal(
      <div className="fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white shadow-lg bg-emerald-600 transition-all duration-300">
        <Wifi className="h-4 w-4 flex-shrink-0" />
        <span>Back online.</span>
      </div>,
      document.body
    );
  }

  return createPortal(
    <div className="fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white shadow-lg bg-amber-500 transition-all duration-300">
      <WifiOff className="h-4 w-4 flex-shrink-0" />
      <span>No internet connection. Some features may be unavailable.</span>
    </div>,
    document.body
  );
}
